'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponent = void 0;
var tslib_1 = require("tslib");
// @ts-ignore - No typings available. TODO: Write them
var web_component_wrapper_1 = tslib_1.__importDefault(require("@gig/web-component-wrapper"));
var vue_1 = tslib_1.__importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var util_1 = require("../util");
var CUSTOM_ELEMENT_PREFIX = 'magic';
var BASE_CSS = fetch('/base.css').then(function (response) { return response.text(); });
/**
 * Registers a custom web component
 * @param component component to register
 * @param delegatesFocus if true, will set the `delegatesFocus` option on the
 *                       attachShadow function. Enable this to be able to focus
 *                       your custom component
 * @param prefix prefix for the name to register the custom component. Defaults
 *               to `magic`
 */
function registerComponent(component, delegatesFocus, prefix) {
    if (prefix === void 0) { prefix = CUSTOM_ELEMENT_PREFIX; }
    var ComponentClass = /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return class_1;
    }(vue_property_decorator_1.Mixins(component)));
    var CustomComponent = web_component_wrapper_1.default(vue_1.default, ComponentClass, !!delegatesFocus, !util_1.isShadyDOM() ? [BASE_CSS] : []);
    // TODO: Correct type hints when '$options' is 'options' on VueConstructor.
    var name = prefix + "-" + component.options.name;
    // TODO: Remove the condition when registering component side effect is removed [GMW-106]
    if (!window.customElements.get(name)) {
        window.customElements.define(name, CustomComponent);
    }
    return ComponentClass;
}
exports.registerComponent = registerComponent;
